import { useCallback, useEffect, useState } from "react";
import { Clock, Wine } from "lucide-react";
import { SlideToAccept } from "@/components/SlideToAccept";
import { toast } from "sonner";
import { api, errMsg, fmtDate, money } from "@/lib/api";

export const OpenRentals = ({ onAccepted }) => {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(null);
  const load = useCallback(() => api.get("/driver/rentals/open").then(({ data }) => setRows(data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, [load]);
  const accept = async (id) => {
    setBusy(id);
    try { await api.post(`/driver/rentals/${id}/accept`); toast.success("Rental accepted"); onAccepted(); }
    catch (e) { toast.error(errMsg(e)); load(); } finally { setBusy(null); }
  };
  return (
    <div className="lux-card p-5 sm:p-6" data-testid="open-rentals">
      <p className="lux-eyebrow">Open hourly / night rentals</p>
      {rows.length === 0 && <p data-testid="open-rentals-empty" className="mt-3 text-sm text-zinc-500">No open rentals right now.</p>}
      <div className="mt-3 divide-y divide-white/5">
        {rows.map((r) => (
          <div key={r.id} data-testid={`open-rental-${r.id}`} className="flex flex-col gap-3 py-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="min-w-0 text-sm">
              <p className="flex items-center gap-2 text-amber-100"><Clock className="h-4 w-4 text-amber-400" />{fmtDate(r.rental?.start_at)} · {r.rental?.hours}h · <span className="capitalize">{r.vehicle_class}</span></p>
              <p className="truncate text-zinc-400">{r.pickup.address}</p>
              <p className="text-xs text-zinc-500">{money(r.fare.total)} prepaid{r.food && <> · <Wine className="inline h-3 w-3" /> F&B request</>}</p>
            </div>
            <div className="w-full sm:w-64"><SlideToAccept testId={`accept-rental-${r.id}`} label="Slide to accept rental" busy={busy === r.id} disabled={!!busy && busy !== r.id} onAccept={() => accept(r.id)} /></div>
          </div>
        ))}
      </div>
    </div>
  );
};
